import React, { Component } from "react";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import n2wordsEN from "n2words/lib/i18n/EN.mjs";
import { FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
class RentPrintEnglish extends Component {
 render() {
  const {
   lang,
   change_Lang,
   rent_invoice_obj,
   index_rentcontrct,
   user,
   primary_logo,
   footer_logo,
   name_en,
   thirdcolor,
  } = this.props;
  // English
  let converter1 =
   rent_invoice_obj.introduction &&
   n2wordsEN(
    parseFloat(rent_invoice_obj.introduction.toString().replace(/,/g, ""))
   );
  let converter2 =
   rent_invoice_obj.paymentmonth &&
   n2wordsEN(
    parseFloat(rent_invoice_obj.paymentmonth.toString().replace(/,/g, ""))
   );
  let converter3 =
   rent_invoice_obj.feelate &&
   n2wordsEN(parseFloat(rent_invoice_obj.feelate.toString().replace(/,/g, "")));
  let converter4 =
   rent_invoice_obj.safly &&
   n2wordsEN(parseFloat(rent_invoice_obj.safly.toString().replace(/,/g, "")));
  let converter5 =
   rent_invoice_obj.fee &&
   n2wordsEN(parseFloat(rent_invoice_obj.fee.toString().replace(/,/g, "")));
  var curr = new Date();
  curr.setDate(curr.getDate());
  let today = curr.toISOString().substr(0, 10);
  return (
   <>
    <div className={`container-fluid`}>
     <div className="row content-containers" id="tbls">
      <div className="col-12">
       <div className="conn">
        <div class="row">
         <div class="col-12  ">
          <img
           src={primary_logo}
           alt="logo"
           className="img-fluid img-responsive"
           style={{
            width: "100%",
           }}
          />
         </div>
        </div>
        <div class="row mt-3">
         <div class="col-4">
          <p
           style={{
            fontSize: "17px",
            color: "#000",
            textAlign: "left",
            fontWeight: "bold",
           }}
           class=" text-uppercase"
          >
           &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
           <Time
            value={rent_invoice_obj.createdAt}
            format="YYYY-MM-DD"
            style={{
             fontSize: "17px",
             color: "#000",
             fontWeight: "bold",
            }}
           />
          </p>
         </div>
         <div class="col-4 d-flex justify-content-center">
          <p
           style={{
            fontSize: "21px",
            color: "#000",
            fontWeight: "bolder",
           }}
           class={`d-flex justify-content-center text-uppercase ${
            lang !== "en" ? "fk" : "fkp"
           } `}
          >
           ({change_Lang("Rental contract")})
          </p>
         </div>
         <div class="col-4 text-right">
          <p
           style={{
            fontSize: "17px",
            color: "#000",
            fontWeight: "bold",
           }}
           class=" text-uppercase"
          >
           {change_Lang("contract number")} #&nbsp;
           {rent_invoice_obj.InvoiceNO}&nbsp;
          </p>
         </div>
        </div>
        <div class="row">
         <div class="col-12">
          <div class="form-group row form-inline">
           <label
            style={{
             fontSize: "22px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label d-flex justify-content-start fkk"
           >
            First Side:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "18px" }}
            >
             {rent_invoice_obj.firstname}
            </label>
           </div>

           <label
            style={{
             fontSize: "22px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label d-flex justify-content-start fkk"
           >
            Second Side:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "18px" }}
            >
             {rent_invoice_obj.tenantId && rent_invoice_obj.tenantId.secondname}
            </label>
           </div>
           <label
            style={{
             fontSize: "22px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label d-flex justify-content-start fkk"
           >
            {" "}
            {change_Lang("first_rule_place")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "18px" }}
            >
             {rent_invoice_obj.available_id &&
              rent_invoice_obj.available_id.Place_ku}
            </label>
           </div>

           <label
            style={{
             fontSize: "22px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 fkk col-form-label d-flex justify-content-start"
           >
            {change_Lang("Type of property")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "18px" }}
            >
             {change_Lang(
              rent_invoice_obj.available_id &&
               rent_invoice_obj.available_id.Property
             )}
            </label>
           </div>

           <label
            style={{
             fontSize: "22px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 fkk col-form-label d-flex justify-content-start"
           >
            {" "}
            {change_Lang("Number of property")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "18px" }}
            >
             {rent_invoice_obj.available_id &&
              rent_invoice_obj.available_id.NOoFProperty}
            </label>
           </div>

           <label
            style={{
             fontSize: "22px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 fkk col-form-label d-flex justify-content-start"
           >
            {" "}
            {change_Lang("Area")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "18px" }}
            >
             {rent_invoice_obj.available_id &&
              rent_invoice_obj.available_id.Area}
             &nbsp;m<sup>2</sup>
            </label>
           </div>
          </div>
          <p
           style={{
            fontSize: "24px",
            color: "#000",
            backgroundColor: "#ebebeb",
            borderRadius: "0px 50px 0px 0px",
           }}
           class="my-3 d-flex justify-content-center fk"
          >
           {change_Lang("agreement")}
          </p>
         </div>
        </div>
        <div className="row">
         <div className="col-12">
          <table className="table" style={{ lineHeight: "0px" }}>
           <tbody>
            <tr style={{ fontSize: "20px" }}>
             <th
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
               paddingTop: "25px",
               listStyleType: "circle",
               fontSize: "20px",
              }}
             >
              1.
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",
               fontWeight: "",
               textAlign: "justify",
               fontSize: "21px",
               borderTop: "none",
              }}
             >
              The first side accepts to rent the above mentioned property to the
              second side.
             </td>
            </tr>
            <tr style={{ fontSize: "20px" }}>
             <th
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
               paddingTop: "25px",
               listStyleType: "circle",
               fontSize: "20px",
              }}
             >
              2.
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",
               fontWeight: "",
               textAlign: "justify",
               fontSize: "21px",
               borderTop: "none",
              }}
             >
              The contract period is (
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={rent_invoice_obj.rental}
               style={{}}
               className="text-center"
              />
              )months, start from &nbsp;(
              <Time
               value={rent_invoice_obj.startdate}
               format="YYYY-MM-DD"
               style={{
                color: "black",
               }}
              />
              )&nbsp;till &nbsp; (
              <Time
               value={rent_invoice_obj.enddate}
               format="YYYY-MM-DD"
               style={{
                color: "black",
               }}
              />
              )&nbsp; , and After the end of the contract, the second party must
              vacate the property without prior notification.
             </td>
            </tr>
            <tr style={{ fontSize: "20px" }}>
             <th
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
               paddingTop: "25px",
               listStyleType: "circle",
               fontSize: "20px",
              }}
             >
              3.
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",
               fontWeight: "",
               textAlign: "justify",
               fontSize: "21px",
               borderTop: "none",
              }}
             >
              both side agreed to the rent amount on an amount of &nbsp;
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={rent_invoice_obj.paymentmonth}
               style={{}}
               className="text-center"
               prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "IQD"}`}
              />
              &nbsp; ( {converter2}
              &nbsp;(
              {rent_invoice_obj.currency === "dolar" ? "US dollar" : "IQD Iraq"}
              ))
             </td>
            </tr>
            <tr style={{ fontSize: "20px" }}>
             <th
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
               paddingTop: "25px",
               listStyleType: "circle",
               fontSize: "20px",
              }}
             >
              4.
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",
               fontWeight: "",
               textAlign: "justify",
               fontSize: "21px",
               borderTop: "none",
              }}
             >
              The second side pays an amount of &nbsp;
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={rent_invoice_obj.introduction}
               style={{}}
               prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "IQD"}`}
               className="text-center"
              />
              &nbsp;
              {converter1}
              &nbsp;(
              {rent_invoice_obj.currency === "dolar" ? "US dollar" : "IQD Iraq"}
              ). as an advance of &nbsp; (
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={rent_invoice_obj.Monthintroduction}
               className="text-center"
              />
              ) months.
             </td>
            </tr>
            <tr style={{ fontSize: "20px" }}>
             <th
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
               paddingTop: "25px",
               listStyleType: "circle",
               fontSize: "20px",
              }}
             >
              5.
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",
               fontWeight: "",
               textAlign: "justify",
               fontSize: "21px",
               borderTop: "none",
              }}
             >
              The second side is obligated to pay an amount of&nbsp;
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               style={{}}
               value={rent_invoice_obj.safly}
               className="text-center"
               prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "IQD"}`}
              />
              &nbsp; ({converter4}
              &nbsp;(
              {rent_invoice_obj.currency === "dolar" ? "US dollar" : "IQD Iraq"}
              )).as insurance to the {name_en} according to the numbered receipt
              paper, and the amount is delivered on the same receipt paper to
              the second side after the end of the contract period, provided
              that the property is delivered without any deficiency by the
              second side to the first side.
             </td>
            </tr>
            <tr style={{ fontSize: "20px" }}>
             <th
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
               paddingTop: "25px",
               listStyleType: "circle",
               fontSize: "20px",
              }}
             >
              6.
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",
               fontWeight: "",
               textAlign: "justify",
               fontSize: "21px",
               borderTop: "none",
              }}
             >
              The second side uses this property for a (
              {rent_invoice_obj.perpose}) purpose, and when using it for any
              other purpose, should be inform the {name_en} with the written
              consent of the first side. Otherwise, the first side has the right
              to void the contract without informing the second side.
             </td>
            </tr>
            <tr style={{ fontSize: "20px" }}>
             <th
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
               paddingTop: "25px",
               listStyleType: "circle",
               fontSize: "20px",
              }}
             >
              7.
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",
               fontWeight: "",
               textAlign: "justify",
               fontSize: "21px",
               borderTop: "none",
              }}
             >
              The second side undertakes to protect the leased property from
              benefiting from it and to preserve it from damage and demolition
              and not to use it in an unwanted manner.
             </td>
            </tr>
            <tr style={{ fontSize: "20px" }}>
             <th
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
               paddingTop: "25px",
               listStyleType: "circle",
               fontSize: "20px",
              }}
             >
              8.
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",
               fontWeight: "",
               textAlign: "justify",
               fontSize: "21px",
               borderTop: "none",
              }}
             >
              From the date of signing the contract, the second side is
              responsible for paying the costs of water, electricity, the
              municipality and any other service.
             </td>
            </tr>
            <tr style={{ fontSize: "20px" }}>
             <th
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
               paddingTop: "25px",
               listStyleType: "circle",
               fontSize: "20px",
              }}
             >
              9.
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",
               fontWeight: "",
               textAlign: "justify",
               fontSize: "21px",
               borderTop: "none",
              }}
             >
              The second side undertakes to pay the rent at the time specified
              in the contract. If he is more than (7) days late, he will deal
              with him according to Paragraph (1) of Article (17) of the Real
              Estate Rental Law of Iraqi Law No. (87) for the year (1979), which
              is vacating the property while bearing the costs of notifying the
              court along with the monthly rent.
             </td>
            </tr>
           </tbody>
          </table>
         </div>
        </div>
       </div>
       <div className="row content-containers" id="tbls_two">
        <div class="col-12  ">
         <img
          src={primary_logo}
          alt="logo"
          className="img-fluid img-responsive"
          style={{
           width: "100%",
          }}
         />
        </div>
       </div>
       <br />
       <div className="row">
        <div className="col-12">
         <table className="table table-borderless">
          <tbody>
           <tr style={{ fontSize: "20px" }}>
            <th
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
              // paddingTop: "25px",
              listStyleType: "circle",
              fontSize: "20px",
             }}
            >
             10.
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "1px",
              color: "black",
              fontWeight: "",
              textAlign: "justify",
              fontSize: "20px",
              borderTop: "none",
             }}
            >
             If the leased property is furnished, the second party must preserve
             the furniture and, when vacating it, hand it over as it was;
             Otherwise, the second side shall be responsible for repairing or
             replacing it at its own risk.
            </td>
           </tr>
           <tr style={{ fontSize: "20px" }}>
            <th
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
              listStyleType: "circle",
              fontSize: "20px",
             }}
            >
             11.
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "1px",
              color: "black",
              fontWeight: "",
              textAlign: "justify",
              fontSize: "20px",
              borderTop: "none",
             }}
            >
             After the end of the contract period, in the event that the second
             side does not abide by vacating the property or renewing the
             contract, the property rent will be &nbsp;
             <NumberFormat
              displayType="text"
              thousandSeparator={true}
              value={rent_invoice_obj.feelate}
              className="text-center"
              prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "IQD"}`}
             />
             &nbsp; ({converter3}
             &nbsp;(
             {rent_invoice_obj.currency === "dolar" ? "US dollar" : "IQD Iraq"}
             ))per day until the case is resolved.
            </td>
           </tr>
           <tr style={{ fontSize: "20px" }}>
            <th
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",

              listStyleType: "circle",
              fontSize: "20px",
             }}
            >
             12.
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "1px",
              color: "black",
              fontWeight: "",
              textAlign: "justify",
              fontSize: "20px",
              borderTop: "none",
             }}
            >
             If ownership of the property is transferred to another side, the
             new owner must abide by the content of this contract.
            </td>
           </tr>
           <tr style={{ fontSize: "20px" }}>
            <th
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",

              listStyleType: "circle",
              fontSize: "20px",
             }}
             scope="row"
            >
             13.
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "1px",
              color: "black",
              fontWeight: "",
              textAlign: "justify",
              fontSize: "20px",
              borderTop: "none",
             }}
            >
             The two sides must pay half of the amount of the rent annually to{" "}
             {name_en} instead of organizing this contract.
            </td>
           </tr>
           <tr style={{ fontSize: "20px" }}>
            <th
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",

              listStyleType: "circle",
              fontSize: "20px",
             }}
            >
             14.
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "1px",
              color: "black",
              fontWeight: "",
              textAlign: "justify",
              fontSize: "20px",
              borderTop: "none",
             }}
            >
             Upon vacating the property, the second side must hand over the
             property as it received it without any defects. Otherwise, it bears
             the responsibility to fill the deficiencies as soon as possible.
            </td>
           </tr>
           <tr style={{ fontSize: "20px" }}>
            <th
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",

              listStyleType: "circle",
              fontSize: "20px",
             }}
            >
             15.
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "1px",
              color: "black",
              fontWeight: "",
              textAlign: "justify",
              fontSize: "20px",
              borderTop: "none",
             }}
            >
             Upon renewal of the contract, the two parties undertake to pay half
             the amount of the rent annually tothe {name_en}.
            </td>
           </tr>
           <tr style={{ fontSize: "20px" }}>
            <th
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",

              listStyleType: "circle",
              fontSize: "20px",
             }}
            >
             16.
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "1px",
              color: "black",
              fontWeight: "",
              textAlign: "justify",
              fontSize: "20px",
              borderTop: "none",
             }}
            >
             The second side is not entitled in any way or creates problems with
             neighbors, otherwise he bears responsibility and the contract is
             terminated.
            </td>
           </tr>
           <tr style={{ fontSize: "20px" }}>
            <th
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",

              listStyleType: "circle",
              fontSize: "20px",
             }}
            >
             17.
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "1px",
              color: "black",
              fontWeight: "",
              textAlign: "justify",
              fontSize: "20px",
              borderTop: "none",
             }}
            >
             When the problems are not resolved through dialogue between the two
             parties, the {name_en} does not bear the responsibility, but the
             two sides must resolve the issues through legal procedures and
             resort to a IDRES court.
            </td>
           </tr>
           <tr style={{ fontSize: "20px" }}>
            <th
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",

              listStyleType: "circle",
              fontSize: "20px",
             }}
            >
             18.
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "1px",
              color: "black",
              fontWeight: "",
              textAlign: "justify",
              fontSize: "20px",
              borderTop: "none",
             }}
            >
             {name_en} is not responsible for any problems that occur between
             the two sides.
            </td>
           </tr>
          </tbody>
         </table>
        </div>
       </div>
       <br />
       <div className="form-inline">
        <label
         style={{
          fontSize: "18px",
          color: "black",
         }}
         className="form-label d-flex justify-content-end"
        >
         {change_Lang("note")}&nbsp;:
        </label>
        &nbsp;
        <p
         style={{
          fontSize: "16px",
          color: "black",
          fontWeight: `${lang !== "en" ? "bold" : ""}`,
          wordSpacing: "4px",
          direction: "ltr",
         }}
        >
         <div
          className="d-flex justify-content-end"
          style={{ direction: "ltr", textAlign: "right" }}
         >
          {rent_invoice_obj.note}
         </div>
        </p>
       </div>
       <br /> <br /> <br /> <br />
       <div className="row">
        <div className="form-group d-flex justify-content-center col-3">
         <label
          style={{
           fontSize: "18px",
           color: "#342800",
           fontWeight: "bold",
          }}
          className="form-label"
         >
          First side (property owner)
         </label>
        </div>
        <div className="col-3">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           {change_Lang("Witness")}
          </label>
         </div>
        </div>
        <div className="col-3">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           {change_Lang("Witness")}
          </label>
         </div>
        </div>
        <div className="col-3 d-flex justify-content-center">
         <div className="form-group ">
          <label
           style={{
            fontSize: "18px",
            color: "#342800",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           {" "}
           Second side (tenant)
          </label>
         </div>
        </div>
       </div>
       <div className="row">
        <div className="col-3 form-group d-flex justify-content-center">
         <label
          style={{
           fontSize: "18px",
           color: "#000",
          }}
          className="form-label"
         >
          {rent_invoice_obj.firstname}
         </label>
        </div>
        <div className="col-3">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "18px",
            color: "#000",
           }}
           className="form-label"
          >
           {rent_invoice_obj.witness1}
          </label>
         </div>
        </div>
        <div className="col-3">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "18px",
            color: "#000",
           }}
           className="form-label"
          >
           {rent_invoice_obj.witness2}
          </label>
         </div>
        </div>
        <div className="col-3 d-flex justify-content-center">
         <div className="form-group ">
          <label
           style={{
            fontSize: "18px",
            color: "#000",
           }}
           className="form-label"
          >
           {rent_invoice_obj.tenantId && rent_invoice_obj.tenantId.secondname}
          </label>
         </div>
        </div>
       </div>
      </div>
     </div>
    </div>
    {/* footer */}
    <div
     className="row"
     style={{
      position: "fixed",
      bottom: 47,
      width: "100%",
     }}
    >
     <div className="col-4 d-flex justify-content-center">
      <h4
       style={{
        fontSize: 21,
        color: "#black",
        letterSpacing: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        direction: "ltr",
        lineHeight: 1.5,
       }}
      >
       <FaPhoneAlt
        style={{
         color: "#fff",
         background: " #000",
         padding: 5,
         fontSize: 25,
         marginRight: 20,
        }}
       />
       {rent_invoice_obj.branchId
        ? rent_invoice_obj.branchId.adressNumber1
        : ""}{" "}
       <br />{" "}
       {rent_invoice_obj.branchId
        ? rent_invoice_obj.branchId.adressNumber2
        : ""}
      </h4>
     </div>
     <div className="col-8 d-flex justify-content-start">
      <label
       style={{
        fontSize: 22,
        color: "#000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
       }}
       className="fk"
      >
       <FaMapMarkerAlt
        style={{
         color: "#fff",
         background: " #000",
         padding: 5,
         fontSize: 25,
        }}
       />
       &nbsp;&nbsp;
       {rent_invoice_obj.branchId ? rent_invoice_obj.branchId.adress : ""}
      </label>
     </div>
    </div>
    <div
     style={{
      position: "fixed",
      bottom: 0,
      width: "100%",
      zIndex: -1,
     }}
    >
     <img src={footer_logo} alt="logo" width="100%" />
    </div>
   </>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  rent_invoice_obj: state.InvoiceReducer.rent_invoice_obj,
  index_rentcontrct: state.Invoice_Reducer.index_rentcontrct,
  user: state.AuthReducer.user,
  secondarycolor: state.HelperReducer.secondarycolor,
  thirdcolor: state.HelperReducer.thirdcolor,
  primary_logo: state.HelperReducer.primary_logo,
  footer_logo: state.HelperReducer.footer_logo,
  name_en: state.HelperReducer.name_en,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(RentPrintEnglish);
